var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTicketingReports01 = function SvgTicketingReports01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ticketing_reports-01_svg2__a",
    x1: 53.75,
    x2: 169.45,
    y1: 191.6,
    y2: 75.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3fe5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#f434e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#dd1de7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#cd0ce8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#c403e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c100e9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#ticketing_reports-01_svg2__a",
    id: "ticketing_reports-01_svg2__b",
    x1: 40.64,
    x2: 156.34,
    y1: 178.49,
    y2: 62.8
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#ticketing_reports-01_svg2__a",
    id: "ticketing_reports-01_svg2__c",
    x1: 50.52,
    x2: 166.21,
    y1: 188.37,
    y2: 72.67
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#ticketing_reports-01_svg2__a",
    id: "ticketing_reports-01_svg2__d",
    x1: -1.33,
    x2: 114.36,
    y1: 136.51,
    y2: 20.82
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#ticketing_reports-01_svg2__a",
    id: "ticketing_reports-01_svg2__e",
    x1: 6.64,
    x2: 122.33,
    y1: 144.48,
    y2: 28.79
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#ticketing_reports-01_svg2__a",
    id: "ticketing_reports-01_svg2__f",
    x1: 38.38,
    x2: 154.07,
    y1: 176.22,
    y2: 60.53
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#ticketing_reports-01_svg2__a",
    id: "ticketing_reports-01_svg2__g",
    x1: 8.36,
    x2: 124.05,
    y1: 146.21,
    y2: 30.51
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#ticketing_reports-01_svg2__a",
    id: "ticketing_reports-01_svg2__h",
    x1: -8.23,
    x2: 107.46,
    y1: 129.61,
    y2: 13.92
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M195.33 92.03h2.33c1.29 0 2.33-1.05 2.33-2.33v-9.34c0-5.85-4.33-10.69-9.95-11.53l-7.93-23.4c-1.23-3.64-5.47-5.66-9.08-4.31L99.14 68.71c-6.21.26-11.19 5.38-11.19 11.65v9.34c0 1.29 1.05 2.33 2.33 2.33h2.33c5.15 0 9.34 4.19 9.34 9.34s-4.19 9.34-9.34 9.34h-2.33c-1.29 0-2.33 1.05-2.33 2.33v9.34c0 6.43 5.24 11.67 11.67 11.67h88.7c6.43 0 11.67-5.24 11.67-11.67v-9.34c0-1.29-1.05-2.33-2.33-2.33h-2.33a9.25 9.25 0 0 1-6.6-2.74 9.3 9.3 0 0 1-2.74-6.6c0-5.15 4.19-9.34 9.34-9.34m-20.66-46.54c1.21-.44 2.62.22 3.03 1.44l7.37 21.76h-72.53zm10.76 65.79c2.64 2.64 6.16 4.1 9.9 4.1v7c0 3.86-3.14 7-7 7h-58.36v-2.33c0-1.29-1.05-2.33-2.33-2.33s-2.33 1.05-2.33 2.33v2.33H99.63c-3.86 0-7-3.14-7-7v-7c7.72 0 14.01-6.28 14.01-14.01s-6.28-14.01-14.01-14.01v-7c0-3.86 3.14-7 7-7h25.68v2.33c0 1.29 1.05 2.33 2.33 2.33s2.33-1.05 2.33-2.33v-2.33h58.36c3.86 0 7 3.14 7 7v7c-7.72 0-14.01 6.28-14.01 14.01 0 3.74 1.46 7.26 4.1 9.91Z",
    style: {
      fill: "url(#ticketing_reports-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.64 85.21c-1.29 0-2.33 1.05-2.33 2.33v7.9c0 1.29 1.05 2.33 2.33 2.33s2.33-1.05 2.33-2.33v-7.9c0-1.29-1.05-2.33-2.33-2.33",
    style: {
      fill: "url(#ticketing_reports-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.64 104.96c-1.29 0-2.33 1.05-2.33 2.33v7.89c0 1.29 1.05 2.33 2.33 2.33s2.33-1.04 2.33-2.33v-7.9c0-1.29-1.05-2.33-2.33-2.33Z",
    style: {
      fill: "url(#ticketing_reports-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.69 78.85h38.37c3.29 0 3.29-5.09 0-5.09H39.69c-3.29 0-3.29 5.09 0 5.09",
    style: {
      fill: "url(#ticketing_reports-01_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.69 97.5h32.95c3.29 0 3.29-5.09 0-5.09H39.69c-3.29 0-3.29 5.09 0 5.09",
    style: {
      fill: "url(#ticketing_reports-01_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.89 164.9h46.65c1.4 0 2.54-1.14 2.54-2.54s-1.14-2.54-2.54-2.54h-1.68v-24.86c0-1.4-1.14-2.54-2.54-2.54H72.11v-8.96c0-1.4-1.14-2.54-2.54-2.54H56.85c-1.4 0-2.54 1.14-2.54 2.54v15.48H44.12c-1.4 0-2.54 1.14-2.54 2.54v18.34H39.9c-1.4 0-2.54 1.14-2.54 2.54s1.14 2.54 2.54 2.54Zm32.25-27.4h7.63v22.31h-7.63zm-12.75-11.51h7.63v33.82h-7.63zm-12.73 18.02h7.63v15.8h-7.63z",
    style: {
      fill: "url(#ticketing_reports-01_svg2__f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.46 158.11h-17.59c-3.26 0-5.91 2.65-5.91 5.91v17.7h-76.9c-.45 0-.82-.37-.82-.82V37.77c0-.45.37-.82.82-.82h99.58c.45 0 .82.37.82.82v17.36h5.09V37.77c0-3.26-2.65-5.91-5.91-5.91h-3.67v-3.18c0-3.26-2.65-5.91-5.91-5.91h-3.68v-3.68c0-3.26-2.65-5.91-5.91-5.91H5.91C2.65 13.18 0 15.83 0 19.09v143.13c0 3.26 2.65 5.91 5.91 5.91h3.68v3.68c0 3.26 2.65 5.91 5.9 5.91h3.68v3.18c0 3.26 2.65 5.91 5.91 5.91h79.44c.66 0 1.32-.27 1.79-.74l23.5-23.39c.48-.48.75-1.13.75-1.8v-16.89h-5.09v14.13ZM19.16 37.77v134.88l-3.67-.02c-.45 0-.82-.37-.82-.82V28.69c0-.45.37-.82.82-.82h17.74c3.29 0 3.29-5.09 0-5.09H15.49c-3.26 0-5.91 2.65-5.91 5.91v134.37H5.9c-.45 0-.82-.37-.82-.82V19.1c0-.45.37-.82.82-.82h99.58c.45 0 .82.37.82.82v3.68H47.47c-3.29 0-3.29 5.09 0 5.09h67.6c.45 0 .82.37.82.82v3.18H25.06c-3.26 0-5.91 2.65-5.91 5.91Zm87.89 140.33v-14.08c0-.45.37-.82.82-.82h14.02z",
    style: {
      fill: "url(#ticketing_reports-01_svg2__g)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.42 54.37h-49.9c-3.29 0-3.29 5.09 0 5.09h49.9c3.29 0 3.29-5.09 0-5.09",
    style: {
      fill: "url(#ticketing_reports-01_svg2__h)"
    }
  }));
};
export default SvgTicketingReports01;